module.exports = __webpack_public_path__ + "static/media/megaman.3f2b60f9.mp3";